function addMassFeatures() {
    // 复杂的自定义覆盖物
    function pointOverlay(point, size, color, info, fgcolor, showText, text) {
        this._station_info = info
        this._point = point;
        this._width = size;
        this._color = color;
        this._fgcolor = fgcolor;
        this._showText = showText;
        this._text = text;
    }
    pointOverlay.prototype.station = 'station info'
    pointOverlay.prototype = new BMap.Overlay();
    pointOverlay.prototype.initialize = function (map) {
        this._map = map;
        var div = this._div = document.createElement("div");
        div.style.position = "absolute";
        div.style.zIndex = BMap.Overlay.getZIndex(this._point.lat);
        div.style.backgroundColor = this._color;
        div.style.border = "1px solid #333";
        div.style.width = this._width + "px";
        div.style.height = this._width + "px";
        div.style.borderRadius = "50%";
        div.style.cursor = "pointer";

        var span = this._span = document.createElement("span");
        span.style.padding = "0";
        span.style.margin = "0";
        span.style.color = this._fgcolor
        span.style.fontSize = '12px'
        span.style.width = this._width + "px";
        span.style.height = this._width + "px";
        span.style.lineHeight = this._width + "px";
        span.style.textAlign = 'center'
        span.style.display = 'inline-block'
        if (this._showText) {
          span.appendChild(document.createTextNode(this._text));
        }
        div.appendChild(span);

        map.getPanes().markerPane.appendChild(div);
        return div;
    }
    pointOverlay.prototype.draw = function () {
        var map = this._map;
        var pixel = map.pointToOverlayPixel(this._point);
        this._div.style.left = pixel.x - this._width/2 + "px";
        this._div.style.top = pixel.y - this._width/2 + "px";
    }
    pointOverlay.prototype.addEventListener = function (event, fun) {
        this._div['on'+event] = fun;
    }

    return pointOverlay
}
export default addMassFeatures


// WEBPACK FOOTER //
// ./src/option/pointOverlays.js